<script lang="ts">
	interface Props {
		height?: string; // Default height
		width?: string; // Default width
		class?: string;
	}

	let { height = '48px', width = '48px', class: className = '' }: Props = $props();
	
</script>

<svg
	{height}
	{width}
	class={className}
	viewBox="0 0 24 24"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
>
	<path
		d="M23.3283 10.75C23.3283 11.4333 22.7617 12 22.0783 12H18.745C18.0617 12 17.495 11.4333 17.495 10.75C17.495 10.0667 18.0617 9.5 18.745 9.5H22.0783C22.7617 9.5 23.3283 10.0667 23.3283 10.75Z"
		fill="currentColor"
	/>
	<path
		d="M19.3664 5.01828L17.1233 7.26141C16.9265 7.45818 16.6773 7.55 16.4281 7.55C16.1788 7.55 15.9296 7.45818 15.7328 7.26141C15.3524 6.881 15.3524 6.25135 15.7328 5.87094L17.9759 3.62781C18.3564 3.2474 18.986 3.2474 19.3664 3.62781C19.7468 4.02134 19.7468 4.63787 19.3664 5.01828Z"
		fill="currentColor"
	/>
	<path
		d="M12.9236 1.96429V4.53571C12.9236 5.06286 12.4864 5.5 11.9593 5.5C11.4321 5.5 10.995 5.06286 10.995 4.53571V1.96429C10.995 1.43714 11.4321 1 11.9593 1C12.4864 1 12.9236 1.43714 12.9236 1.96429Z"
		fill="currentColor"
	/>
	<path
		d="M10.995 4.53571V1.96429C10.995 1.43714 11.4321 1 11.9593 1C12.4864 1 12.9236 1.43714 12.9236 1.96429V4.53571C12.9236 5.06286 12.4864 5.5 11.9593 5.5C11.4321 5.5 10.995 5.06286 10.995 4.53571Z"
		fill="currentColor"
	/>
	<path
		d="M16.7001 13.6728L15.9431 12.9158L14.2051 11.1885C14.6529 10.4635 14.5676 9.51458 13.9492 8.88551C13.5974 8.53366 13.1282 8.34174 12.6271 8.34174C12.2753 8.34174 11.9341 8.4377 11.6462 8.61895L9.90827 6.89168L9.15125 6.13466C8.84205 5.82546 8.34092 5.81479 8.02106 6.13466C7.71185 6.44386 7.71185 6.95565 8.02106 7.26485L8.27695 7.52075L3.4683 13.7048L1.75168 15.4214C0.749438 16.4343 0.749438 18.0763 1.75168 19.0892L3.73485 21.0724C4.24664 21.5842 4.90769 21.8294 5.57941 21.8294C6.24047 21.8294 6.90153 21.5842 7.41331 21.0724L8.58615 19.8889L10.4627 21.7654C10.6226 21.9254 10.8252 22 11.0278 22C11.2304 22 11.4436 21.9254 11.5929 21.7654C11.9021 21.4562 11.9021 20.9445 11.5929 20.6353L9.80164 18.8333L15.314 14.5471L15.5699 14.803C15.7192 14.963 15.9217 15.0376 16.135 15.0376C16.3376 15.0376 16.5402 14.963 16.7001 14.803C17.0093 14.4938 17.0093 13.982 16.7001 13.6728ZM6.28312 19.9422C5.88862 20.3261 5.25955 20.3261 4.87571 19.9422L2.88188 17.959C2.49804 17.5645 2.49804 16.9355 2.88188 16.5516L4.06538 15.3681L7.45596 18.7587L6.28312 19.9422Z"
		fill="currentColor"
	/>
	<path
		d="M19.3664 5.01828L17.1233 7.26141C16.9265 7.45818 16.6773 7.55 16.4281 7.55C16.1788 7.55 15.9296 7.45818 15.7328 7.26141C15.3524 6.881 15.3524 6.25135 15.7328 5.87094L17.9759 3.62781C18.3564 3.2474 18.986 3.2474 19.3664 3.62781C19.7468 4.02134 19.7468 4.63787 19.3664 5.01828Z"
		fill="currentColor"
	/>
	<path
		d="M23.3283 10.75C23.3283 11.4333 22.7617 12 22.0783 12H18.745C18.0617 12 17.495 11.4333 17.495 10.75C17.495 10.0667 18.0617 9.5 18.745 9.5H22.0783C22.7617 9.5 23.3283 10.0667 23.3283 10.75Z"
		fill="currentColor"
	/>
</svg>
